// extracted by mini-css-extract-plugin
export default {"updateIllustration":"Bundle_updateIllustration__VSpRg","placeHolderShimmer":"Bundle_placeHolderShimmer__BBl0o"};